// extracted by mini-css-extract-plugin
module.exports = {"ModalTitle":"LoginModal_ModalTitle__HCOBD","ModalForm":"LoginModal_ModalForm__1tl1J","ModalFormInputs":"LoginModal_ModalFormInputs__39nH1","span":"LoginModal_span__2uPaR"};